export default __webpack_public_path__ + "static/media/grrenarrow.0a06007e.svg";